<nav mat-tab-nav-bar>
  <a mat-tab-link *ngFor="let link of navLinks" [routerLink]="link.path" [active]="rla.isActive" routerLinkActive
    #rla="routerLinkActive" [routerLinkActiveOptions]="{exact:false}">
    {{link.label | translate | uppercase}}
  </a>
</nav>

<router-outlet></router-outlet>